import { Trash2 } from 'lucide-react'
import { removePoint } from './use-area-polygon'
import type { AreaGeo } from './use-area-polygon'
import { m } from '@/lib/paraglide/messages'

type Props = {
    geo: AreaGeo
    onChange: (geo: AreaGeo) => void
    readOnly?: boolean
}

/** Bảng toạ độ từng đỉnh polygon; xoá điểm khi không ở chế độ chỉ xem. */
export function AreaCoordTable({ geo, onChange, readOnly }: Props) {
    if (geo.paths.length === 0) {
        return (
            <p className="text-xs text-muted-foreground">
                {m.grower_area_no_points()}
            </p>
        )
    }
    return (
        <div className="overflow-hidden rounded-md border text-xs">
            <div className="grid grid-cols-[1fr_1fr_40px] bg-muted font-medium text-muted-foreground">
                <div className="px-2.5 py-2">{m.grower_coord_lng()}</div>
                <div className="px-2.5 py-2">{m.grower_coord_lat()}</div>
                <div />
            </div>
            {geo.paths.map((p, i) => (
                <div
                    key={i}
                    data-testid="coord-row"
                    className="grid grid-cols-[1fr_1fr_40px] border-t tabular-nums"
                >
                    <div className="px-2.5 py-2">{p.lng.toFixed(5)}</div>
                    <div className="px-2.5 py-2">{p.lat.toFixed(5)}</div>
                    {!readOnly && (
                        <button
                            type="button"
                            className="flex items-center justify-center text-destructive"
                            onClick={() => onChange(removePoint(geo, i))}
                            aria-label={m.action_delete()}
                        >
                            <Trash2 className="size-3.5" />
                        </button>
                    )}
                </div>
            ))}
        </div>
    )
}
